export const HEADERS = [
  'HEADER.USER',
  'HEADER.JOURNAL-ACTION',
  'HEADER.CREATED',
];
